import { useState } from 'react';


interface IBasicBreadcrumb {
  contentId: number;
  title: string;
  onClick?: () => void;
};

const UseBasicBreadcrumbsForContentModals = ({onBreadcrumbClick}:{onBreadcrumbClick?: (id: number, title: string) => void; }) => {
    const [breadcrumbs, setBreadcrumbs] = useState<IBasicBreadcrumb[]>([]);

    const setBreadcrumb = (contentId: number, title: string) => {
        setBreadcrumbs((prev) => {
            const existingIndex = prev.findIndex((b) => b.contentId === contentId);

            if (existingIndex !== -1) {
                // If breadcrumb already exists then bin all the trailing ones
                return prev.slice(0, existingIndex + 1);
            } else {
                //add a new one
                return [
                    ...prev,
                    {
                        contentId: contentId,
                        title,
                        onClick: () => {
                            if (onBreadcrumbClick) {
                                onBreadcrumbClick(contentId, title);
                            }
                        },
                    },
                ];
            }
        });
    }
    return { breadcrumbs, setBreadcrumb };
}
    
export default UseBasicBreadcrumbsForContentModals

